
import Candle2 from "../../../assets/filled/Candle2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Candle2Icon({ className, dataTestid = "Candle2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Candle2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
